export const avatarUrl = (width = 300): string =>
	`//images.ctfassets.net/bncv3c2gt878/18M7LZPr4Dah1nSJagy6bk/09d2f6f4f373d983d0214ecd896bd89f/Me_2022-08?w=${width}&fm=webp`
